
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
	import PickerDate from '@/components/picker-date.vue';
  import Dialog from '@/components/dialog.vue';
	import Message from '@/components/message.vue';
	import {
		handleClipboard
	} from '@/utils/clipboard'
	import {
		nextDay,
		getSearchDate
	} from "@/utils"
  import {
    orderSettleunsettledlist,
    orderSettlerecordlist,
    orderSettlesettleFirstverify,
    orderSettlesettleFirstunsignedOrderDetailList,

    orderSettlesettleTime,
    orderSettlesettleVerify
  } from "@/api/order"
  import {getUserInfo } from '@/utils/storage';
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
      PickerDate,
      'slz-dialog': Dialog,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
		private defaultThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png';
    private radioType = -1
    private radioList = [
      {value:-1,label:'未结算'},
      {value:0,label:'结算中'},
      {value:1,label:'已结算'},
      {value:2,label:'已驳回'},
    ]
    private keywords = ''
    private filterTime = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private chooselist:any = []

    private orderNo = ''
    private tablelist2:any = []
    private orderNo2 = ''
    private keywords2 = ''
    private filterTime2 = ''
    private SettleMoneyAll = 0
    private orderNo3 = ''
    private keywords3 = ''
    private filterTime3 = ''

    private rowmsg:any = {}
    private logsShow = false


    private initiateShow = false
    private initiateMsg = {
      startTime:'',
      endTime:'',
      result:{}
    }
    private pickerOptions:any = {
      disabledDate:(e)=>{
        return e.getTime() <= new Date('2023-11-01').getTime() - 1000*60*60*24
      }
    }
    private pickerOptions2:any = {
      disabledDate:(e)=>{
        return e.getTime() >= new Date().getTime() - 1000*60*60*24
      }
    }
    private verifyMsg:any = {
      IsAllowSettle:false,
      VerifyFailureType:1,
      MessageList:[],
      UnsignedOrderDetailInfoGroupByProductList:[]
    }
    private nocontractShow = false
    private numTestShow = false
    private tipsShow = false
    private unsignedShow = false
    private noPricesupplierShow = false
    private noPriceRoutuanShow = false
    private frequentlyShow = false
    private intervalSmallShow = false

    private mounted () {
      this.filterTime = [getSearchDate(1,false)[0],getSearchDate(2,false)[0]].join('/')
      this.filterTime2 = [getSearchDate(1,false)[0],getSearchDate(2,false)[0]].join('/')
      this.changelist()
    }
    activated () {
      this.tipsShow = false
      this.changelist()
    }


    private async toverify(){
      if(!this.initiateMsg.startTime||!this.initiateMsg.endTime){
        this.$message.error('请选择结算日期')
        return 
      }
      try{
        this.tableloading = true
        let res = await orderSettlesettleVerify({
          StartTime:this.initiateMsg.startTime,
          EndTime:nextDay(this.initiateMsg.endTime,1)
        })
        if(res.IsSuccess){
          this.verifyMsg = res.Result
          if(res.Result.IsAllowSettle){
            this.$router.push({
              path:'settleDetails',
              query:{
                StartTime:this.initiateMsg.startTime,
                EndTime:nextDay(this.initiateMsg.endTime,1),
                FinanceOrderSettleRecordId:''
              }
            })
          }else{
            if(res.Result.VerifyFailureType==1){
              this.nocontractShow = true
            }else if(res.Result.VerifyFailureType==2){
              this.numTestShow = true
            }else if(res.Result.VerifyFailureType==3){
              this.tipsShow = true
            }else if(res.Result.VerifyFailureType==4){
              this.unsignedShow = true
            }else if(res.Result.VerifyFailureType==5){
              this.noPricesupplierShow = true
            }else if(res.Result.VerifyFailureType==6){
              this.noPriceRoutuanShow = true
            }else if(res.Result.VerifyFailureType==7){
              this.frequentlyShow = true
            }else if(res.Result.VerifyFailureType==8){
              this.intervalSmallShow = true
            }
          }
          this.closeinitiate()
        }
      }finally{
        this.tableloading = false
      }
    }
    private closeinitiate(){
      this.initiateMsg = {
        startTime:'',
        endTime:'',
        result:{}
      }
      this.initiateShow = false
    }
    private async initiateSettle(){
      try{
        this.tableloading = true
        let res = await orderSettlesettleTime({})
        if(res.IsSuccess){
          if(res.Result.PreFinanceOrderSettleRecordId){
            this.initiateMsg.result = res.Result||{}
            this.initiateMsg.startTime = nextDay(res.Result.PreSettleEndDate,1)
          }
          this.initiateShow = true
        }
      }finally{
        this.tableloading = false
      }
    }


    private keepSettle(row){
      let data:any = {
        FinanceOrderSettleRecordId:row.Id,
      }
      if(this.filterTime){
        let time = this.filterTime.split('/')
        data.StartTime = time[0]
        data.EndTime = nextDay(time[1],1)
      }
      this.$router.push({
        path:'settleDetails',
        query:data
      })
      // console.log(SettleState)
    }
    private torules(row){
      this.$router.push({
        name:'settleTemplatedetail',
        query:{
          Type:'1',
          ProductId:row.ProductId
        }
      })
    }
    private get userInfo() {
      return getUserInfo()
    }
    private orderDetails(row,type){
      let data:any = {
        FinanceOrderSettleRecordId:row.Id,
        ProductId:row.ProductId,
        SpecValue:row.SpecValue,
        FinanceOrderSettleOrderDetailFromPageType:type
      }
      if(this.radioType==-1){
        if(this.filterTime){
          let time = this.filterTime.split('/')
          data.StartTime = time[0]
          data.EndTime = nextDay(time[1],1)
        }
      }else if(this.radioType==1){
        if(this.filterTime2){
          let time = this.filterTime2.split('/')
          data.StartTime = time[0]
          data.EndTime = nextDay(time[1],1)
        }
      }
      // console.log(data)
      this.$router.push({
        path:'orderDetails',
        query:data
      })
    }
    private copy(e){
      // console.log(this.verifyMsg)
      let text = `★ 【${this.userInfo.ProviderName}】截止${getSearchDate(1,false)[1]}未签收的订单\n`
      this.verifyMsg.UnsignedOrderDetailInfoGroupByProductList.map(v=>{
        text+=`★商品名称：${v.ProductName}\n`
        v.UnsignedOrderDetailInfoList.map(x=>{
          text+=`${x.ChildOrderNo} ${x.IsDuringSupport?'（售后中）':''}\n`
        })
      })
      handleClipboard(text,e)
    }
    private changePage(e){
      this.pageNo = e
      this.changelist()
    }
    private async gettablelist(){
      let t = this.filterTime.split('/')
      if((new Date(t[1]).getTime()-new Date(t[0]).getTime())/1000/60/60/24 > 90){
        this.$message.error('最多选择跨度90天的日期')
        return
      }
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        }
        if(this.filterTime){
          let time = this.filterTime.split('/')
          data.StartTime = time[0]
          data.EndTime = nextDay(time[1],1)
        }
        let res:any = await orderSettleunsettledlist(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.rollTime = v.OpenTime.replace(/-/g,'/').substring(0,10)+'-'+v.TakedownTime.replace(/-/g,'/').substring(0,10)
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.changelist()
    }
    private clearSearch(){
      if(this.radioType==-1){
        this.keywords = ''
        this.filterTime = [getSearchDate(1,false)[0],getSearchDate(2,false)[0]].join('/')
      }else if(this.radioType==0){
        this.orderNo = ''
      }else if(this.radioType==1){
        this.orderNo2 = ''
        this.keywords2 = ''
        this.filterTime2 = [getSearchDate(1,false)[0],getSearchDate(2,false)[0]].join('/')
      }else if(this.radioType==2){
        this.orderNo3 = ''
        this.keywords3 = ''
        this.filterTime3 = [getSearchDate(1,false)[0],getSearchDate(2,false)[0]].join('/')
      }
      this.doSearch()
    }
    private exportfile(){
      let url = location.origin
      if(this.radioType==-1){
        url += '/provider/finance/orderSettle/unsettled/list'
        url += '?Keywords=' + encodeURIComponent(this.keywords)
        if(this.filterTime){
          let time = this.filterTime.split('/')
          url += '&StartTime=' + time[0]
          url += '&EndTime=' + nextDay(time[1],1)
        }
      }else{
        url += '/provider/finance/orderSettle/record/list'
        if(this.radioType==0){
          url += '?BillNo=' + this.orderNo
        }else if(this.radioType==1){
          url += '?BillNo=' + this.orderNo2
          url += '&ProductInfo=' + encodeURIComponent(this.keywords2)
          if(this.filterTime2){
            let time = this.filterTime2.split('/')
            url += '&StartTime=' + time[0]
            url += '&EndTime=' + nextDay(time[1],1)
          }
        }else if(this.radioType==2){
          url += '?BillNo=' + this.orderNo3
          url += '&ProductInfo=' + encodeURIComponent(this.keywords3)
          if(this.filterTime3){
            let time = this.filterTime3.split('/')
            url += '&StartTime=' + time[0]
            url += '&EndTime=' + nextDay(time[1],1)
          }
        }
        url += '&SettleState=' + this.radioType
      }
      window.open(url)
    }
    private async gettablelist2(){
      try{
        this.tableloading = true
        let data:any = {
          BillNo:this.orderNo,
          SettleState:this.radioType,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        }
        let res:any = await orderSettlerecordlist(data)
        if(res.IsSuccess){
          this.tablelist2 = res.Result.Results.map(v=>{
            v.SubmitOrderStartTime = v.SubmitOrderStartTime?.substring(0,10)
            v.SubmitOrderEndDate = v.SubmitOrderEndDate?.substring(0,10)
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private async gettablelist3(){
      let t = this.filterTime2.split('/')
      if((new Date(t[1]).getTime()-new Date(t[0]).getTime())/1000/60/60/24 > 90){
        this.$message.error('最多选择跨度90天的日期')
        return
      }
      try{
        this.tableloading = true
        let data:any = {
          ProductInfo:this.keywords2,
          BillNo:this.orderNo2,
          SettleState:this.radioType,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        }
        if(this.filterTime2){
          let time = this.filterTime2.split('/')
          data.StartTime = time[0]
          data.EndTime = nextDay(time[1],1)
        }
        let res:any = await orderSettlerecordlist(data)
        if(res.IsSuccess){
            // console.log(res)
          this.tablelist2 = res.Result.Results.map(v=>{
            v.SubmitOrderStartTime = v.SubmitOrderStartTime?.substring(0,10)
            v.SubmitOrderEndDate = v.SubmitOrderEndDate?.substring(0,10)
            return v
          })
          this.total = res.Result.Total
          if(this.radioType==1){
            this.SettleMoneyAll = res.Result.SettleMoneyAll
          }
        }
      }finally{
        this.tableloading = false
      }
    }
    private async gettablelist4(){
      let t = this.filterTime3.split('/')
      if((new Date(t[1]).getTime()-new Date(t[0]).getTime())/1000/60/60/24 > 90){
        this.$message.error('最多选择跨度90天的日期')
        return
      }
      try{
        this.tableloading = true
        let data:any = {
          ProductInfo:this.keywords3,
          BillNo:this.orderNo3,
          SettleState:this.radioType,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        }
        if(this.filterTime3){
          let time = this.filterTime3.split('/')
          data.StartTime = time[0]
          data.EndTime = nextDay(time[1],1)
        }
        let res:any = await orderSettlerecordlist(data)
        if(res.IsSuccess){
            // console.log(res)
          this.tablelist2 = res.Result.Results.map(v=>{
            v.SubmitOrderStartTime = v.SubmitOrderStartTime?.substring(0,10)
            v.SubmitOrderEndDate = v.SubmitOrderEndDate?.substring(0,10)
            return v
          })
          this.total = res.Result.Total
          if(this.radioType==1){
            this.SettleMoneyAll = res.Result.SettleMoneyAll
          }
        }
      }finally{
        this.tableloading = false
      }
    }
    private changRadio(e){
      this.pageNo = 1
      this.changelist()
    }
    private async changelist(){
      if(this.radioType==-1){
        this.gettablelist()
      }else if(this.radioType==0){
        this.gettablelist2()
      }else if(this.radioType==1){
        this.gettablelist3()
      }else{
        this.gettablelist4()
      }
    }
  }
